import { ContainerErrorType } from '@fluidframework/container-definitions';
import { OWHErrorType, ContainerLoadErrorType } from '@fluidx/office-fluid-types';
export function isContainerGenericError(error) {
    return error.errorType === ContainerErrorType.genericError;
}
export function isContainerThrottlingError(error) {
    return error.errorType === ContainerErrorType.throttlingError;
}
/**
 * Returns value indicating whether given error object indicates that container version is no longer valid and upgrade is required.
 * @param error Error object
 *
 * TODO: Consider promoting ContainerUpgradeRequired to FF and expose it via ErrorType
 */ export function isContainerUpgradeRequiredError(error) {
    return error.errorType === OWHErrorType.ContainerUpgradeRequired && /* eslint-disable-next-line @typescript-eslint/no-explicit-any
-- TODO: Using 'any' type defeats the purpose of TypeScript. Consider replacing it with a concrete type, or 'unknown'. */ error.error?.name === OWHErrorType.ContainerUpgradeRequired;
}
/**
 * Returns value indicating whether given error object indicates that container had an issue on the load pipeline, but is more specific than a generic error.
 * @param error Error object
 *
 * TODO: Consider promoting ContainerUpgradeRequired to FF and expose it via ErrorType
 */ export function isContainerLoadError(error) {
    /* eslint-disable-next-line @typescript-eslint/no-explicit-any
-- TODO: Using 'any' type defeats the purpose of TypeScript. Consider replacing it with a concrete type, or 'unknown'. */ return Object.values(ContainerLoadErrorType).find((e)=>e === error.name || e === error.errorType);
}
/**
 * Match a error against known fluid container error types
 * @param error potential container error
 * @returns ContainerErrorType in case of a match
 */ export function tryMatchContainerErrorType(error) {
    if (typeof error === 'object') {
        const typedError = error;
        if (isContainerUpgradeRequiredError(typedError)) {
            return OWHErrorType.ContainerUpgradeRequired;
        }
        if (isContainerGenericError(typedError)) {
            return ContainerErrorType.genericError;
        }
        // Should warnings be handled distinctly from errors?
        if (isContainerThrottlingError(typedError)) {
            return ContainerErrorType.throttlingError;
        }
        const containerLoadError = isContainerLoadError(typedError);
        if (containerLoadError) {
            return containerLoadError;
        }
    // ... try match any other known container error types
    }
    return;
}
